module.exports = "/_next/static/images/calendar-monotone-05ad752767db5c1ac9233b6455c3d1e5.svg";